import script from "./BlackList.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlackList.vue?vue&type=script&lang=ts&setup=true"

import "./BlackList.vue?vue&type=style&index=0&id=1e9a9623&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9a9623"]])

export default __exports__